import { useState, useEffect } from 'react';
import { homepageConfig, HomepageConfig } from '../config/homepageConfig';

interface UseHomepageDataReturn {
  data: HomepageConfig;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useHomepageData = (): UseHomepageDataReturn => {
  const [data, setData] = useState<HomepageConfig>(homepageConfig);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      // 这里可以添加API调用来获取动态数据
      // 例如：获取最新的统计数据、用户评价等
      
      // 模拟API调用延迟
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // 可以在这里添加动态数据获取逻辑
      // const response = await fetch('/api/homepage-data');
      // const dynamicData = await response.json();
      
      // 目前使用静态配置
      setData(homepageConfig);
    } catch (err) {
      setError(err instanceof Error ? err.message : '获取数据失败');
      // 发生错误时使用默认配置
      setData(homepageConfig);
    } finally {
      setLoading(false);
    }
  };

  const refetch = () => {
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    loading,
    error,
    refetch,
  };
};

// 获取实时统计数据的Hook
export const useStatsData = () => {
  const [stats, setStats] = useState(homepageConfig.stats);
  const [loading, setLoading] = useState(false);

  const fetchStats = async () => {
    setLoading(true);
    try {
      // 这里可以添加API调用来获取实时统计数据
      // const response = await fetch('/api/stats');
      // const statsData = await response.json();
      
      // 模拟动态数据更新
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // 目前使用静态数据
      setStats(homepageConfig.stats);
    } catch (error) {
      console.error('获取统计数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    
    // 可以设置定时更新统计数据
    const interval = setInterval(fetchStats, 60000); // 每分钟更新一次
    
    return () => clearInterval(interval);
  }, []);

  return { stats, loading, refetch: fetchStats };
};